function initTrackingGA4() {

  function sendDataToGA4(element) {
    const gaEvent = {
      "event": "user_interaction",
      "event_name": "interaction_quiz",
      "interaction": {
        "interaction_element_type": "bouton",
        "interaction_element_label": element.element_label,
        "interaction_type": "acces-contenu",
        "lead_step_nb": element.step_nb,
        "lead_step_name": element.step_name,
        "page_section": "body",
        "interaction_behavior": element.behavior ? element.behavior : null,
        "link_url": element.link_url ? element.link_url : null
      }
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(gaEvent);
    resetDataLayer();
  }

  function resetDataLayer() {
    const resEvent = {
      "event": "reset_dataLayer",
      "event_name": "reset_dataLayer",
      "interaction": {
        "interaction_element_type": undefined,
        "interaction_element_label": undefined,
        "interaction_type": undefined,
        "interaction_behavior": undefined,
        "page_section": undefined,
        "page_subsection": undefined,
        "lead_step_nb": undefined,
        "lead_step_name": undefined
      }
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(resEvent);
  }

  return {
    sendDataToGA4,
    resetDataLayer
  }
}


window.initTrackingGA4 = initTrackingGA4();
export default window.initTrackingGA4;
